import React from 'react'
import { Image } from '@telus/koodo-ui-kit'

const ESimQrCard = ({ qrCode, qrCodeRef }) => {
  return (
    <div
      ref={qrCodeRef}
      className="flex flex-col justify-center items-center border-4 p-2 rounded-md border-solid border-black bg-white"
      style={{ width: '244px', height: '244px', breakInside: 'avoid' }}
    >
      {qrCode && (
        <Image
          src={qrCode}
          width={230}
          height={230}
          className="object-contain"
          alt="Scan QR Code"
        />
      )}
    </div>
  )
}

export default ESimQrCard
